// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { CredentialBilling } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Model/Billing';
import { ERR_BILL_CRED, SUC_BILL_CRED } from '../../../../utils/strings';

const useBillCredential = () => {
  const { submit } = useExerciseSubmission(
    CredentialBilling.CredentialBilling_Bill,
    SUC_BILL_CRED,
    ERR_BILL_CRED,
  );

  return submit;
};

export default useBillCredential;
